import {getConfig} from '../../getConfig';
import {initializeGTM as init} from './gtm';
export {gtmSetupUser, gtmTrack} from './gtm';

const {gtmId} = getConfig();

export const initializeGTM = () => init({id: gtmId});
